/**
 * Purchase Order Detail container
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Actions from './actions';
import Deliveries from '../../Components/Deliveries/Deliveries';
import {
  availabilitiesSelector,
  blocksSelector,
  deliverablePurchaseOrdersSelector,
  deliveriesSelector,
  errorSelector,
  loadingSelector,
  locationsSelector,
} from './selectors';
import AdminActions from '../Admin/actions';
import { vendorSelector } from '../Admin/selectors';
import { currentUserSelector } from '../App/selectors';

/**
 * Properties to be provided to the Purchase Order Detail component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  error: errorSelector(state),
  blocks: blocksSelector(state),
  currentUser: currentUserSelector(state),
  deliveries: deliveriesSelector(state),
  deliverablePurchaseOrders: deliverablePurchaseOrdersSelector(state),
  availabilities: availabilitiesSelector(state),
  locations: locationsSelector(state),
  vendors: vendorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch purchase order detail actions
 */
const mapDispatchToProps = (dispatch) => ({
  createBlock: (block, cb) => dispatch(Actions.createBlock(block, cb)),
  createDelivery: (delivery, purchaseOrderNumbers, cb) =>
    dispatch(Actions.createDelivery(delivery, purchaseOrderNumbers, cb)),
  getDelivery: (deliveryId) => dispatch(Actions.getDelivery(deliveryId)),
  getDeliveries: (options) => dispatch(Actions.getDeliveries(options)),
  getLocations: () => dispatch(Actions.getLocations()),
  getDeliverablePurchaseOrders: (id, locationId, isVendorId, params) =>
    dispatch(
      Actions.getDeliverablePurchaseOrders(id, locationId, isVendorId, params),
    ),
  updateBlock: (blockId, block, cb) =>
    dispatch(Actions.updateBlock(blockId, block, cb)),
  updateDelivery: (deliveryId, delivery, purchaseOrderNumbers, cb) =>
    dispatch(
      Actions.updateDelivery(deliveryId, delivery, purchaseOrderNumbers, cb),
    ),
  checkInDelivery: (deliveryId, deliveredAt, cb) =>
    dispatch(Actions.checkInDelivery(deliveryId, deliveredAt, cb)),
  removeBlock: (blockId) => dispatch(Actions.removeBlock(blockId)),
  removeDelivery: (deliveryId, reason) =>
    dispatch(Actions.removeDelivery(deliveryId, reason)),
  getAvailabilities: (options) => dispatch(Actions.getAvailabilities(options)),
  fetchVendors: (search) => dispatch(AdminActions.fetchVendors(search)),
});

/**
 * Connects login state to the Purchase Order Detail component
 *
 * @param {object} mapStateToProps data object to become props for the Purchase Order Detail component
 * @param {object} mapDispatchToProps Purchase Order Detail actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Deliveries),
);
